var exports = {
  "w": "xfd349460--5df13b--header",
  "v": "xfd349460--5df13b--tabs",
};

module.exports = exports;
